import { render, staticRenderFns } from "./MultiPaymentContent.vue?vue&type=template&id=4ea29570&lang=pug"
import script from "./MultiPaymentContent.vue?vue&type=script&lang=js"
export * from "./MultiPaymentContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports